module.exports = __webpack_public_path__ + "img/logo.7f781069.png";